<template>
    <div class="partner">
        <div class="business-summary">
            <div class="business-card sales-card">
                <div class="business-icon"><img class="business-icon-svg sales-icon-svg" :src="salesIcon" alt="京东余额" />
                </div>
                <div class="business-content">
                    <div class="business-value">{{ remainLimit ?? '-' }}</div>
                    <div class="business-label">京东余额</div>
                </div>
            </div>
            <!-- <div class="business-card cost-card">
                <div class="business-icon"><img class="business-icon-svg cost-icon-svg" :src="costIcon" alt="成本金额" /></div>
                <div class="business-content"><div class="business-value">{{ businessData.costAmount ?? '-' }}</div><div class="business-label">成本金额</div></div>
            </div>
            <div class="business-card profit-card">
                <div class="business-icon"><img class="business-icon-svg profit-icon-svg" :src="profitIcon" alt="利润金额" /></div>
                <div class="business-content"><div class="business-value">{{ businessData.netProfit ?? '-' }}</div><div class="business-label">利润金额</div></div>
            </div>
            <div class="business-card margin-card">
                <div class="business-icon"><img class="business-icon-svg margin-icon-svg" :src="marginIcon" alt="平均毛利率" /></div>
                <div class="business-content"><div class="business-value">{{ businessData.avgGrossMarginRate ?? '-' }}</div><div class="business-label">平均毛利率</div></div>
            </div> -->
        </div>
        <div>
            <div class="header_btn" @keyup.enter="searchBtn">
                <el-input class="common_ipt" v-model="bizOrderNo" placeholder="请输入商城订单号" clearable />
                <el-input class="common_ipt" v-model="jdOrderId" placeholder="请输入京东订单号" clearable />
                <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始时间"
                    end-placeholder="结束时间" size="large" style="width: 400;margin:0 10px 10px 0;" clearable
                    :disabled-date="disabledDate" />

                <el-button size="large" style="margin:0 0 10px 0;" @click="resetBtn">重置</el-button>
                <el-button type="primary" size="large" style="margin:0 0 10px 10px;" :loading="showLoading"
                    @click="searchBtn"><el-icon class="cancelgu">
                        <Search />
                    </el-icon>搜索</el-button>
            </div>
        </div>

        <div class="summation">
            <div class="hint">统计 : {{ count }}条</div>
        </div>

        <el-table class="manage-list-table" :data="filterTableData" style="width: 100%" :fit="true" row-key="unionId"
            border :header-cell-style="{ background: '#F5F7FA' }" :empty-text="texts">
            <!-- 商城订单号   -->
            <el-table-column fixed label="商城订单号" prop="bizOrderNo" :formatter="formatEmptyValue" align="center"
                :show-overflow-tooltip='true' min-width="120">
            </el-table-column>
            <!-- 京东订单号  -->
            <el-table-column label="京东订单号" prop="jdOrderId" :formatter="formatEmptyValue" align="center"
                :show-overflow-tooltip='true' min-width="120">
            </el-table-column>
            <!-- 交易类型  -->
            <el-table-column label="交易类型" prop="tradeTypeName" :formatter="formatEmptyValue" align="center"
                :show-overflow-tooltip='true' min-width="120">
            </el-table-column>
            <!-- 交易金额   -->
            <el-table-column label="交易金额" prop="amount" :formatter="formatEmptyValue" align="center"
                :show-overflow-tooltip='true' min-width="100">
            </el-table-column>
            <!-- 交易时间 -->
            <el-table-column label="交易时间" prop="createdDate" align="center"
                :show-overflow-tooltip='true' min-width="100">
            </el-table-column>
            <!-- 备注   -->
            <el-table-column label="备注" prop="notePub" :formatter="formatEmptyValue" align="center"
                :show-overflow-tooltip='true' min-width="180">
            </el-table-column>
        </el-table>

        <el-pagination :hide-on-single-page="true" layout="prev, pager, next,sizes" :page-sizes="[10, 15, 20, 25]"
            :current-page="currentPage" :page-size="pagesize" :total="count" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />

    </div>
</template>

<script>
export default {
    name: 'tianmaBalance'
}
</script>

<script setup>
import { Search } from '@element-plus/icons-vue'
import { ref, onMounted } from 'vue';
import moments from 'moment'
import { ElMessage } from 'element-plus';
import {
    queryJingDongBalanceChangeList, queryJingDongAccountBalance
} from "../../../request/api";
import qs from 'qs';
import costIcon from './svg/chengben.svg';
import marginIcon from './svg/lilv.svg';
import profitIcon from './svg/lirun.svg';
import salesIcon from './svg/xiaoshou.svg';
const texts = ref('暂无数据');
const bizOrderNo = ref(''); //商城订单号
const jdOrderId = ref(''); //京东订单号

const time = ref([]);
const currentPage = ref(1);
const pagesize = ref(10);
const filterTableData = ref([]);
const businessData = ref({});
const remainLimit = ref(null); //京东余额
const count = ref(0);
const showLoading = ref(true);
const isEmptyValue = (value) => value === null || value === undefined || value === '';

const formatEmptyValue = (row, column, cellValue) => {
    return isEmptyValue(cellValue) ? '-' : cellValue;
};

const formatSecondsTime = (row, column, cellValue) => {
    if (isEmptyValue(cellValue)) return '-';
    const date = moments.unix(Number(cellValue));
    return date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : '-';
};

const getOrderQueryParams = () => {
    let orderStartTime = '';
    let orderEndTime = '';
    if (time.value?.length === 2) {
        orderStartTime = moments(time.value[0]).startOf('day').unix();
        orderEndTime = moments(time.value[1]).endOf('day').unix();
    }

    return {
        bizOrderNo: bizOrderNo.value,
        jdOrderId: jdOrderId.value,
        startTime: orderStartTime,
        endTime: orderEndTime,
    };
}
const getBalance = () => {

    queryJingDongAccountBalance().then((res) => {
        if (res.data.code == 0) {
            remainLimit.value = res.data.data.remainLimit;
        } else {
            ElMessage.error(res.data.msg);
        }
    });
}
const dataInfo = () => {
    const params = {
        ...getOrderQueryParams(),
        pageNum: Number(currentPage.value),
        pageSize: Number(pagesize.value)
    };
    queryJingDongBalanceChangeList(params).then((res) => {
        if (res.data.code == 0) {
            filterTableData.value = res.data.data.data;
            count.value = res.data.data.total;
            showLoading.value = false;
        } else {
            ElMessage.error(res.data.msg);
        }
    });
}

const disabledDate = (time) => {
    return time.getTime() > Date.now();
};

const searchBtn = () => {
    showLoading.value = true;
    currentPage.value = 1;
    dataInfo();
    getBalance();
}

const resetBtn = () => {
    bizOrderNo.value = '';
    jdOrderId.value = '';
    time.value = [];
    currentPage.value = 1;
    pagesize.value = 10;
    showLoading.value = true;
    dataInfo();
    getBalance();
}

const handleSizeChange = (val) => {
    showLoading.value = true;
    pagesize.value = val;
    currentPage.value = 1;
    dataInfo();
    getBalance();
}

const handleCurrentChange = (val) => {
    currentPage.value = val;
    showLoading.value = true;
    dataInfo();
    getBalance();
}

const reach = (row, column, cellValue) => {
    if (cellValue) {
        return moments(cellValue * 1000).format("YYYY-MM-DD HH:mm")
    }
    return '';
};

onMounted(() => {
    dataInfo();
    getBalance();
})

</script>

<style lang="scss" scoped>
/* 修复展开箭头动画 */
::v-deep .el-table__expand-icon {
    transition: transform 0.3s;

    &.el-table__expand-icon--expanded {
        transform: rotate(90deg);
    }
}

/* 确保展开内容区域样式 */
::v-deep .el-table__expanded-cell {
    // padding: 10px !important;
    //   background-color: #fafafa;

    .el-table {
        // margin: 10px 0;
    }
}

::v-deep .el-input__inner {
    height: 40px;
}

/* 与 allocating 页面保持一致的表格表头及行高 */
::v-deep .el-table__header {
    margin: 0 !important;
}

::v-deep .el-table .el-table__cell {
    padding-top: 15px;
    padding-bottom: 15px;
}

.el-pagination {
    margin-top: 10px;
}

.partner {
    height: calc(100vh - 170px);
    background-color: #FFFFFF;
    width: 95%;
    padding: 20px;
    overflow: auto;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 5px;
    margin: 15px auto;
}

.business-summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    width: 98%;
    gap: 10px;
    margin: 0 0 20px 0;
}

.business-card {
    display: flex;
    height: 100px;
    min-width: 0;
    overflow: hidden;
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 4px;
}

.business-icon {
    display: grid;
    flex: 0 0 100px;
    place-items: center;
    color: #fff;
    font-size: 30px;
}

.business-icon-svg {
    display: block;
    width: 42px;
    height: 42px;
    object-fit: contain;
}

.sales-icon-svg {
    filter: brightness(0) invert(1);
}

.cost-icon-svg {
    filter: brightness(0) invert(1);
}

.profit-icon-svg {
    filter: brightness(0) invert(1);
}

.margin-icon-svg {
    filter: brightness(0) invert(1);
}

.business-content {
    display: flex;
    flex: 1;
    min-width: 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
}

.business-value {
    max-width: 100%;
    overflow: hidden;
    font-size: 25px;
    font-weight: 600;
    line-height: 32px;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.business-label {
    color: #909399;
    font-size: 14px;
    line-height: 22px;
}

//.sales-card .business-icon { background: #ff7b31; }.sales-card .business-value { color: #ff7b31; }
.sales-card .business-icon {
    background: #ff0f23;
}

.sales-card .business-value {
    color: #ff0f23;
}

.cost-card .business-icon {
    background: #1b8ffb;
}

.cost-card .business-value {
    color: #1b8ffb;
}

.profit-card .business-icon {
    background: #07c160;
}

.profit-card .business-value {
    color: #07c160;
}

.margin-card .business-icon {
    background: #13227a;
}

.margin-card .business-value {
    color: #13227a;
}

@media (max-width: 1200px) {
    .business-summary {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 640px) {
    .business-summary {
        grid-template-columns: 1fr;
    }

    .business-icon {
        flex-basis: 72px;
    }
}


.summation {
    display: flex;
    justify-content: space-between;
}

.hint {
    font-size: 14px;
    color: #909399;
    margin-bottom: 15px;
}

.header_btn {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.common_ipt {
    width: 220px;
    height: 40px !important;
    margin-right: 10px;
    margin-bottom: 10px;
}

.common_ipt3 {
    width: 220px;
}
</style>
